import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fg } from '@atlaskit/platform-feature-flags';
import { utils } from '@atlaskit/util-service-support';
import { fetchAggResponseWithCache } from './fetch-agg-response-with-cache';
var DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
export function fetchAggResponse(_x) {
  return _fetchAggResponse.apply(this, arguments);
}
function _fetchAggResponse() {
  _fetchAggResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var graphQuery, variables, operationName, _ref$aggAbsoluteUrl, url, cache, options;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          graphQuery = _ref.graphQuery, variables = _ref.variables, operationName = _ref.operationName, _ref$aggAbsoluteUrl = _ref.aggAbsoluteUrl, url = _ref$aggAbsoluteUrl === void 0 ? DEFAULT_GRAPHQL_ENDPOINT : _ref$aggAbsoluteUrl, cache = _ref.cache;
          options = {
            requestInit: {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
              })
            },
            queryParams: _objectSpread({}, operationName && {
              q: operationName
            })
          }; // if there's a ttl use fetch with in-mem cacheing
          if (!(cache && fg('kd_fe_enable_api_cache'))) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", fetchAggResponseWithCache({
            graphQuery: graphQuery,
            variables: variables,
            operationName: operationName,
            cache: cache
          }));
        case 4:
          return _context.abrupt("return", utils.requestService({
            url: url
          }, options));
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchAggResponse.apply(this, arguments);
}